import { render, staticRenderFns } from "./Brasov.vue?vue&type=template&id=787f3a8c&"
import script from "./Brasov.vue?vue&type=script&lang=js&"
export * from "./Brasov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports